export const branchConstants = {
  GETALL_REQUEST: 'BRANCHES_GETALL_REQUEST',
  GETALL_SUCCESS: 'BRANCHES_GETALL_SUCCESS',
  GETALL_FAILURE: 'BRANCHES_GETALL_FAILURE',

  GET_REQUEST: 'BRANCHES_GET_REQUEST',
  GET_SUCCESS: 'BRANCHES_GET_SUCCESS',
  GET_FAILURE: 'BRANCHES_GET_FAILURE',

  ADD_REQUEST: 'BRANCHES_ADD_REQUEST',
  ADD_SUCCESS: 'BRANCHES_ADD_SUCCESS',
  ADD_FAILURE: 'BRANCHES_ADD_FAILURE',

  UPDATE_REQUEST: 'BRANCHES_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'BRANCHES_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'BRANCHES_UPDATE_FAILURE',
}